import React from 'react';

import { Box } from 'edenred-ui';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { useGetDetailsQuery } from '@epi-api/user';

import OnboardingStep from './components/OnboardingStep/OnboardingStep';

const OnboardingStepper = () => {
  const { t } = useTranslation();
  const { sizeExtraExtraLarge, fontSemiBold } = useTheme();
  const { data: customerData } = useGetDetailsQuery();
  const { isBenefitsSet, isEmployeesSet, isMoneyTransfered, isLoadInitiated } =
    customerData ?? {};
  const loadDone = !!(isMoneyTransfered || isLoadInitiated);
  const isSelectBenefitActive = !isBenefitsSet;
  const isAddEmployeesActive = isBenefitsSet && !isEmployeesSet;
  const isLoadBalanceActive = isBenefitsSet && isEmployeesSet && !loadDone;
  const isHidden =
    !customerData || (isBenefitsSet && isEmployeesSet && loadDone);

  if (isHidden) return null;

  return (
    <Box
      display={'flex'}
      gap={5}
      alignItems="center"
      maxWidth={'1375px'}
      pt={5}
      margin={'0 auto'}
      pl={5}
      pr={5}
    >
      <Box fontSize={sizeExtraExtraLarge} fontWeight={fontSemiBold}>
        {t('components.benefit_onboarding.title')}
      </Box>
      <Box ml="auto" display="flex" gap={2}>
        <OnboardingStep
          stepNumber={1}
          label={t('components.benefit_onboarding.stepper.select_benefits')}
          isActive={isSelectBenefitActive}
          isDone={!!customerData?.isBenefitsSet}
        />
        <OnboardingStep
          stepNumber={2}
          label={t('components.benefit_onboarding.stepper.add_employees')}
          isActive={isAddEmployeesActive}
          isDone={!!customerData?.isEmployeesSet}
        />
        <OnboardingStep
          stepNumber={3}
          label={t('components.benefit_onboarding.stepper.load_balance')}
          isActive={isLoadBalanceActive}
          isDone={
            !!(customerData?.isMoneyTransfered || customerData?.isLoadInitiated)
          }
        />
      </Box>
    </Box>
  );
};

export default OnboardingStepper;
